const document = [{
  desc: '文档管理分页列表',
  options: {
    url: '/DocumentManagement/queryPage',
    method: 'post'
  }
}, {
  desc: '文档分类',
  options: {
    url: '/DocumentManagement/queryDocumentType',
    method: 'post'
  }
}, {
  desc: '上传文件',
  options: {
    url: '/DocumentManagement/uploadFile',
    method: 'post'
  }
}, {
  desc: '文档新增修改',
  options: {
    url: '/DocumentManagement/AddOrUpdateDocumentManagement',
    method: 'post'
  }
}]
export default document



// WEBPACK FOOTER //
// ./src/api/document.js